import { useFeedbackFlowStore } from "../stores/feedback-flow-store";

export function useFeedbackFlow() {
	// Session state
	const formSlug = useFeedbackFlowStore((state) => state.formSlug);
	const reviewId = useFeedbackFlowStore((state) => state.reviewId);

	// Flow state
	const currentFlowType = useFeedbackFlowStore(
		(state) => state.currentFlowType,
	);
	const flowSteps = useFeedbackFlowStore((state) => state.flowSteps);
	const currentStepIndex = useFeedbackFlowStore(
		(state) => state.currentStepIndex,
	);
	const currentQuestionIndex = useFeedbackFlowStore(
		(state) => state.currentQuestionIndex,
	);

	// Data state
	const data = useFeedbackFlowStore((state) => state.data);
	const isDirty = useFeedbackFlowStore((state) => state.isDirty);
	const isComplete = useFeedbackFlowStore((state) => state.isComplete);

	// API state
	const isSubmitting = useFeedbackFlowStore((state) => state.isSubmitting);
	const submitError = useFeedbackFlowStore((state) => state.submitError);

	// Data setters
	const setRating = useFeedbackFlowStore((state) => state.setRating);
	const setContextText = useFeedbackFlowStore(
		(state) => state.setContextText,
	);
	const setConsent = useFeedbackFlowStore((state) => state.setConsent);
	const setUserInfo = useFeedbackFlowStore((state) => state.setUserInfo);
	const setCompanyInfo = useFeedbackFlowStore(
		(state) => state.setCompanyInfo,
	);
	const setQuestionAnswer = useFeedbackFlowStore(
		(state) => state.setQuestionAnswer,
	);

	// Navigation
	const nextStep = useFeedbackFlowStore((state) => state.nextStep);
	const prevStep = useFeedbackFlowStore((state) => state.prevStep);
	const canGoBack = useFeedbackFlowStore((state) => state.canGoBack);
	const canProceed = useFeedbackFlowStore((state) => state.canProceed);
	const getCurrentStep = useFeedbackFlowStore(
		(state) => state.getCurrentStep,
	);

	// API actions
	const initializeFlow = useFeedbackFlowStore(
		(state) => state.initializeFlow,
	);
	const createSubmission = useFeedbackFlowStore(
		(state) => state.createSubmission,
	);
	const saveCurrentStepData = useFeedbackFlowStore(
		(state) => state.saveCurrentStepData,
	);
	const hasPendingUploads = useFeedbackFlowStore(
		(state) => state.hasPendingUploads,
	);
	const uploadAllFiles = useFeedbackFlowStore(
		(state) => state.uploadAllFiles,
	);
	const uploadVideo = useFeedbackFlowStore((state) => state.uploadVideo);
	const uploadAudio = useFeedbackFlowStore((state) => state.uploadAudio);
	const finalizeSubmission = useFeedbackFlowStore(
		(state) => state.finalizeSubmission,
	);

	// Incremental submission methods
	const createSubmissionFromRating = useFeedbackFlowStore(
		(state) => state.createSubmissionFromRating,
	);
	const updateQuestionAnswerStep = useFeedbackFlowStore(
		(state) => state.updateQuestionAnswerStep,
	);
	const updateUserInfoStep = useFeedbackFlowStore(
		(state) => state.updateUserInfoStep,
	);
	const updateCompanyInfoStep = useFeedbackFlowStore(
		(state) => state.updateCompanyInfoStep,
	);
	const updateConsentAndComplete = useFeedbackFlowStore(
		(state) => state.updateConsentAndComplete,
	);

	// Flow control
	const reset = useFeedbackFlowStore((state) => state.reset);
	const complete = useFeedbackFlowStore((state) => state.complete);

	return {
		// Session state
		formSlug,
		reviewId,

		// Flow state
		currentFlowType,
		flowSteps,
		currentStepIndex,
		currentQuestionIndex,

		// Data state
		data,
		isDirty,
		isComplete,

		// API state
		isSubmitting,
		submitError,

		// Data setters
		setRating,
		setContextText,
		setConsent,
		setUserInfo,
		setCompanyInfo,
		setQuestionAnswer,

		// Navigation
		nextStep,
		prevStep,
		canGoBack,
		canProceed,
		getCurrentStep,

		// API actions
		initializeFlow,
		createSubmission,
		saveCurrentStepData,
		hasPendingUploads,
		uploadAllFiles,
		uploadVideo,
		uploadAudio,
		finalizeSubmission,

		// Incremental submission methods
		createSubmissionFromRating,
		updateQuestionAnswerStep,
		updateUserInfoStep,
		updateCompanyInfoStep,
		updateConsentAndComplete,

		// Flow control
		reset,
		complete,
	};
}
